import { useState, useEffect } from 'react';

function getWindowDimensions() {
  const { innerWidth, innerHeight, outerWidth, outerHeight } = window;
  return {
    innerWidth,
    innerHeight,
    outerWidth,
    outerHeight,
  };
}

export default function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowDimensions;
}
